/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * True when the request's lastKnownEtag lagged the server and the save reconciled.
 */
export type SubmissionEtagReconciledFromStaleClient = boolean | null;
